export default __webpack_public_path__ + "static/media/facebook-round-color.5abbe9d9.svg";